export class PerformActionConstants {

    public static XBRL_ACTION_NAVIGATION_NAME: string = "rendereddocumentsummarydiv_";

    public static CreateNavigationIdForDocument(documentId: string): string {
        return this.XBRL_ACTION_NAVIGATION_NAME + documentId;
    }
}